<template>
  <div class="menber-dialog">
    <el-dialog :title="getDialogTitle()" :visible.sync="dialogVisible" :before-close="handleClose" width="1000px">
      <div class="form">
        <el-form ref="form" :inline="true" :model="form" label-width="120px" :rules="formRules">
          <el-form-item label="地址" prop="areaCode" style="width: 100% !important">
            <el-cascader v-model="form.regionCode" :props="props" :options="regionOptions"
               @change="regionChange" clearable></el-cascader>

            <el-cascader ref="address" v-model="form.areaCode" :props="props" :options="streetOptions"
               @change="streetChange" clearable></el-cascader>
          </el-form-item>
          <!-- <el-form-item label="土地类型" prop="landType">
            <el-select v-model="form.landType" clearable @change="changeLandType">
              <el-option v-for="item in landType" :key="item.id" :label="item.label" :value="item.label"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="托管类型" prop="orderType">
            <el-radio-group v-model="form.orderType">
              <el-radio :label="'1'">全程托管</el-radio>
              <el-radio :label="'2'">环节托管</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="种养品种" prop="cropCode">
            <!-- <el-select v-model="form.cropCode" @change="changeZypz" filterable clearable placeholder="请选择托管作物" multiple
              no-data-text="无数据（请先选择土地类型）">
              <el-option v-for="item in zypzArr" :key="item.id" :label="item.label" :value="item.label"></el-option>
            </el-select> -->
            <el-cascader v-model="form.cropCode" clearable @change="changeZypz" :options="zypzArr"
              :props="zypzType"></el-cascader>
          </el-form-item>
          <!-- 托管环节 -->
          <el-form-item v-if="form.orderType === '2'" label="托管环节" prop="orderContent">
            <el-select v-model="form.orderContent" placeholder="请选择托管环节" multiple no-data-text="无数据（请先选择种养品种）">
              <el-option v-for="item in tghjArr" :key="item.id" :label="item.label" :value="item.label"></el-option>
            </el-select>
          </el-form-item>


          <el-form-item label="托管面积" prop="landArea">
            <el-input placeholder="请填写托管面积" type="number" min="1" v-model="form.landArea" @blur="calculateTotal()"
              @change="calculateTotal()">
              <template slot="append">亩</template>
            </el-input>
          </el-form-item>
          <el-form-item v-if="form.orderType !== '2'" label="每季保底产量" prop="seasonYield">
            <el-input v-model="form.seasonYield" placeholder="如玉米500KG/亩/季"></el-input>
          </el-form-item>
          <el-form-item label="单价" prop="univalentPrice">
            <el-input v-model="form.univalentPrice" type="number" min="1" style="width: 224px" @blur="calculateTotal"
              @change="calculateTotal()"><template slot="append">元/亩</template></el-input>
          </el-form-item>
          <el-form-item label="总价" prop="estimatePrice">
            <el-input v-model="form.estimatePrice" type="number" min="1" style="width: 224px"
              @blur="calculateTotal($event, 'all')" @change="calculateTotal($event, 'all')"><template
                slot="append">元</template></el-input>
          </el-form-item>

          <el-form-item v-if="form.orderType !== '2'" label="首付款比例" prop="downPayment" style="width: 100% !important">
            <el-input v-model.number="form.downPayment" style="width: 35% !important"
              placeholder="合约签订当日首付比例"></el-input>
            % (可首付比例为空,在备注填写详细付款方式)
          </el-form-item>
          <el-form-item label="托管时间" required style="display: flex; align-items: center; width: 100% !important;">
            <el-date-picker v-model="form.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始时间"
              :picker-options="pickerOptions1" style="width: 40%;" />
            <span style="display: inline-block; width: 30px; text-align: center;">至</span>
            <el-date-picker v-model="form.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束时间"
              :picker-options="pickerOptions2" style="width: 40%;" />
          </el-form-item>
          <!-- 新增加选择流转地块 -->
          <el-form-item label="托管地块" prop="landList" style="width: 100% !important;">
            <div class="land-select-container">
              <div class="land-select-header">
                <el-button type="primary" icon="el-icon-plus" @click="openLandDialog">
                  选择流转地块
                </el-button>
                <span v-if="selectedLands.length" class="selected-count">
                  已选择 {{ selectedLands.length }} 个地块
                </span>
              </div>

              <div v-if="selectedLands.length" class="selected-lands-info">
                <div class="selected-lands-header">
                  <i class="el-icon-location"></i>
                  <span>已选地块详情</span>
                </div>
                <div class="selected-lands-content">
                  <div v-for="(land, index) in selectedLands" :key="land.id" class="land-item">
                    <div class="land-item-info">
                      <span class="land-name">{{ land.xmmc || land.name || `地块${land.id}` }}</span>
                      <!-- <span class="land-area">{{ land.zcmj }}亩</span> -->
                    </div>
                    <div class="land-item-details">
                      <span class="land-detail">流转年限：{{ land.lznx }}年</span>
                      <span class="land-detail">发布时间：{{ land.fbsj }}</span>
                    </div>
                  </div>
                </div>
                <div class="total-area">
                  <span>总面积：{{selectedLands.reduce((sum, land) => sum + (land.zcmj || 0), 0)}}亩</span>
                </div>
              </div>

              <!-- <div v-else class="no-selected-lands">
                <i class="el-icon-info"></i>
                <span>请选择需要托管的流转地块</span>
              </div> -->
            </div>
          </el-form-item>

          <br />
          <el-form-item label="其他说明" prop="remark">
            <el-input v-model="form.remark" style="width: 100%" type="textarea"></el-input>
          </el-form-item>
          <el-form-item v-show="form.orderType !== '2'" label="产权凭证" prop="landCertificateUrl"
            style="width: 100% !important">
            <el-upload ref="upload" multiple action="" name="files" :limit="8" :file-list="fileList"
              :on-change="uploadCqpz" :on-remove="removeCqpz" :before-upload="shangcuan" :auto-upload="false"
              :on-preview="handleFileClick" :accept="'.pdf, .PDF,.jpg, .JPG, .png, .PNG'" list-type="picture">
              <el-button type="primary" :loading="loading">{{
                loading ? "上传中" : "上传文件"
                }}</el-button>
              <span style="color: red">*请上传PDF或图片文件</span>
            </el-upload>
          </el-form-item>
          <el-form-item label="现场照片" prop="livePhotos" style="width: 100% !important">
            <span style="color: red">(单张图片最大6M，最多上传6张。支持：JPG/JPEG/GIF/PNG格式。)</span>
            <el-upload ref="pic1" multiple action="" name="files" :limit="6" :file-list="fileList1"
              list-type="picture-card" :before-upload="beforeUpload" :on-change="uploadXczp" :on-remove="removeXczp"
              :on-exceed="handleExceed2" :auto-upload="false">
              <i slot="default" title="选取文件" class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <template>
          <table style="width:100%">
            <!-- 农户名单 -->
            <tr>
              <td colspan="5">
                <p style="float: left">
                  <el-checkbox v-model="checked1">我是代表多名农户统一托管土地
                  </el-checkbox>
                </p>
              </td>
            </tr>
            <tr v-if="checked1">
              <td colspan="5" style="margin: aout">
                <table border="1" class="farmers-table">
                  <thead>
                    <tr>
                      <td colspan="5">
                        <h2>农户名单</h2>
                      </td>
                    </tr>
                    <tr>
                      <th>农户姓名</th>
                      <th>面积（亩）</th>
                      <th>身份证号</th>
                      <th>联系方式</th>
                      <th style="width: 120px;">操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(farmer, index) in form.farmerList" :key="index">
                      <td :class="{ 'error-cell': errorStatus[index].nameError }" style="width: 130px !important">
                        <input type="text" v-model="farmer.farmerNames"
                          @blur="validateInput(farmer.farmerNames, 'name', index)" />
                      </td>
                      <td :class="{ 'error-cell': errorStatus[index].areaError }" style="width: 130px !important">
                        <input type="text" v-model="farmer.area" @blur="validateInput(farmer.area, 'area', index)" />
                      </td>
                      <td :class="{ 'error-cell': errorStatus[index].identityError }" style="width: 380px !important">
                        <input type="text" v-model="farmer.idCard" @blur="validateInput(farmer.idCard, 'id', index)" />
                      </td>
                      <td :class="{ 'error-cell': errorStatus[index].phoneError }" style="width: 130px !important">
                        <input type="text" v-model="farmer.phoneNumber"
                          @blur="validateInput(farmer.phoneNumber, 'phone', index)" />
                      </td>
                      <td>
                        <div class="farmer-btn-group">
                          <el-button type="primary" icon="el-icon-plus" size="mini"
                            @click="addFarmerRow(index)">添加</el-button>
                          <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeFarmerRow(index)"
                            :disabled="!isEdit && form.farmerList.length === 1">删除</el-button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="5" style="text-align:center; padding: 12px 0;">
                        <el-button type="primary" size="mini" @click="addNFarmers(10)">添加10行农户</el-button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </td>
            </tr>
          </table>

        </template>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-top: 20px" @click="back">取消</el-button>
        <el-button type="primary" @click="submit">{{
          isEdit ? "保存" : "发布"
          }}</el-button>
      </div>
    </el-dialog>
    <LandSelectDialog :visible.sync="landDialogVisible" :selected-lands="selectedLands" :land-list="landList"
      @land-selected="handleLandSelected" @close="landDialogVisible = false" />
  </div>
</template>
<script>
import { uploadFile, deleteFile } from "@/api/fileApi";

import { getLandType, addOrderAsset, findUserXmxxs, getCropContentCascading, getCropContent, getXzqArr, selectLandDetail } from "@/api/add";
import { wytgAdd } from "@/api/projectManage";
import { mapGetters } from "vuex";
import { removeEmptyChildren } from "@/js/utils/util";
import LandSelectDialog from './LandSelectDialog.vue';

// 测试是否是无用代码
// import { uploadPic, getRegionList } from "@/api/projectManage";
// import { download } from "@/api/add";
// import { set } from "vue";
export default {
  data() {
    var checkArea = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请选择地址"));
      } else {
        setTimeout(() => {
          if (this.areaHasChild) {
            callback(new Error("请选到最后一级"));
          } else {
            callback();
          }
        }, 100);
      }
    };
    // 新增日期格式化函数
    function formatDate(date) {
      const d = new Date(date);
      const month = '' + (d.getMonth() + 1);
      const day = '' + d.getDate();
      const year = d.getFullYear();
      return [
        year,
        month.padStart(2, '0'),
        day.padStart(2, '0')
      ].join('-');
    }
    const today = new Date();
    const nextYear = new Date();
    nextYear.setFullYear(today.getFullYear() + 1);

    return {
      zypzType: {
        label: "label",
        children: "children",
        value: "value",
        multiple: true,
        // checkStrictly: true,
      },
      isAdd: false,
      tempCropCodeLabels: null, // 临时保存的cropCode labels，用于编辑回显
      tempOrderContent: null, // 临时保存的orderContent，用于编辑回显
      errorStatus: [],//新增-农户清单
      checked1: false, //新增- 默认不选中
      areaHasChild: true, //管理是否写到最后一级别了
      keyForm: 0, //动态刷新el-cascader的地区
      loading: false,
      baseUrl: window.globalUrl.BASE_API,
      isEdit: false, //当前页面状态：编辑还是新增
      farmerList: [], // 农户名单
      dialogVisible: true,
      xczpIds: [],
      cqpzIds: [],
      regionOptions: [{}],
      streetOptions: [{}],
      tempregionCode: "",
      props: {
        label: "areaName",
        children: "children",
        value: "id",
        checkStrictly: true,
      },
      form: {
        cropCode: [],
        orderContent: [],
        orderType: "1",
        landCertificateUrl: "",
        areaCode: "",
        estimatePrice: null,
        landArea: null,
        univalentPrice: null,
        landType: null,
        downPayment: null, //合约签订当日首付比例u
        farmerList: [],
        startDate: formatDate(today),
        endDate: formatDate(nextYear),
      },
      pickerOptions1: {
        //开始日期的校验
        disabledDate: (time) => {
          // 获取当前日期并将时间调整为 00:00:00
          const today = new Date().setHours(0, 0, 0, 0);
          // 获取要比较的日期并将时间调整为 00:00:00
          const compareDate = new Date(time).setHours(0, 0, 0, 0);
          return (
            compareDate < today ||
            time.getTime() > new Date(this.form.endDate).getTime()
          );
        },
      },
      pickerOptions2: {
        //结束日期的校验
        disabledDate: (time) => {
          // 获取当前日期并将时间调整为 00:00:00
          const today = new Date().setHours(0, 0, 0, 0);
          // 获取要比较的日期并将时间调整为 00:00:00
          const compareDate = new Date(time).setHours(0, 0, 0, 0);
          return (
            compareDate < today ||
            time.getTime() < new Date(this.form.startDate).getTime()
          );
        },
      },
      fileList: [],
      fileList1: [],
      files: [],
      files1: [],
      zypzArr: [],
      tghjArr: [],
      landType: [],
      formRules: {
        landType: [
          { required: true, message: "请选择土地类型", trigger: "change" },
        ],
        orderContent: [
          { required: true, message: "请选择托管环节", trigger: "change" },
        ],
        cropCode: [
          { required: true, message: "请选择托管作物", trigger: "change" },
        ],
        orderType: [
          { required: true, message: "请选择托管类型", trigger: "change" },
        ],
        landArea: [
          { required: true, message: "请输入托管面积", trigger: "blur" },
        ],
        startDate: [
          { required: true, message: "请选择托管开始时间", trigger: "change" },
        ],
        endDate: [
          { required: true, message: "请选择托管结束时间", trigger: "change" },
        ],
        // Time: [{ required: true, message: "请选择托管时间", trigger: "blur" }],
        univalentPrice: [
          { required: true, message: "请输入单价", trigger: "blur" },
        ],
        estimatePrice: [
          { required: true, message: "请输入总价", trigger: "blur" },
        ],
        areaCode: [{ required: true, validator: checkArea, trigger: "change" }],
        // landCertificateUrl: [
        //   { required: true, message: "请上传产权凭证", trigger: "change" },
        // ],
      },
      TrueUnitPrice: "", //实际单价
      defaultTime: "", //获取事件
      landDialogVisible: false, // 控制地块选择弹窗
      selectedLands: [],        // 已选地块对象数组
      landNames: '',            // 已选地块名称字符串
      landList: [], // 新增
      CoordinateList: [], // 新增：存储地块坐标列表
    };
  },

  mounted() {
    this.getRegions();
    // this.findUserXmxxs()
    setTimeout(() => {
      this.areaHasChild = this.identityObj.areaCode ? false : true;
      this.form.areaCode = this.identityObj.areaCode;
      if (this.identityObj.areaCode.length >= 6) {
        this.getlandScope(this.identityObj.areaCode.substring(0, 6));
      }
      this.form.areaName = this.identityObj.areaFullName
        ? this.identityObj.areaFullName.split("/").join("")
        : "";
    }, 100);
  },
  // 获取store里定义的全局变量
  computed: mapGetters(["userInfo", "identityObj"]),
  watch: {
    // landType() {
    //   if (this.form.landType) {
    //     this.changeLandType(this.form.landType);
    //   }
    // },
    // zypzArr() {
    //   this.changeZypz(this.form.cropCode);
    // },
    // "form.landType": function (newValue, oldValue) {

    // },
    'form.cropCode': function (newValue, oldValue) {

      // 只在多选模式下处理
      if (!Array.isArray(newValue) || newValue.length === 0) return;

      // 获取新旧父节点集合
      const getParentSet = arr => new Set(arr.map(item => item[0]));
      const newParents = getParentSet(newValue);
      const oldParents = getParentSet(oldValue || []);

      // 找到新选择的父节点（即新值有而旧值没有的父节点）
      const addedParents = [...newParents].filter(p => !oldParents.has(p));

      // 如果有新增父节点，只保留这些父节点下的子节点
      if (addedParents.length > 0) {
        this.form.cropCode = newValue.filter(item => addedParents.includes(item[0]));
      }
      // 如果是减少父节点（如取消选择），也只保留当前还存在的父节点下的子节点
      else if (newParents.size < oldParents.size) {
        this.form.cropCode = newValue.filter(item => newParents.has(item[0]));
      }

      // 新增：有值时获取托管环节
      // if (this.form.cropCode && this.form.cropCode.length > 0) {
      //     this.changeZypz(this.form.cropCode);
      //   }

    },
    "form.farmerList": function () {
      if (this.form.farmerList) {
        this.checked1 = this.form.farmerList.length >= 1 ? true : false;
        if (this.form.farmerList.length) {
          for (let i = 0; i < this.form.farmerList.length - 1; i++) {
            this.errorStatus.push({
              nameError: false,
              areaError: false,
              identityError: false,
              phoneError: false,
            });
          }
        }
      }
    },
    checked1: function () {
      if (this.checked1 == false) {
        this.form.farmerList = [];

      } else {
        if (!this.isAdd) {
          for (let i = 0; i < 10; i++) {
            this.form.farmerList.push({
              id: 0,
              farmerNames: "",
              area: "",
              idCard: "",
              phoneNumber: "",
              xmbh: "",
              createTime: "",
              updateTime: "",
              createId: "",
              updateId: "",
              deleted: "",
            });
            // 添加对应的错误状态到 errorStatus 数组
            this.errorStatus.push({
              nameError: false,
              areaError: false,
              identityError: false,
              phoneError: false,
            });
          }
        }

      }
    },
    // 新增：托管类型切换时，若为全程托管则清空托管环节
    'form.orderType': function (val) {
      if (val === '1') {
        // 全程托管，自动选中所有托管环节
        this.form.orderContent = this.tghjArr.map(item => item.label);
        // 全程托管默认增加一年时间
        this.setEndDateByOrderType('1');
      } else {
        // 环节托管，清空已选环节
        this.form.orderContent = [];
        // 环节托管默认增加七天
        this.setEndDateByOrderType('2');
      }

      // 托管类型切换时，清空已选择的流转地块，让用户重新选择
      this.selectedLands = [];
      this.landNames = '';
      this.CoordinateList = [];
      this.form.landList = [];
      this.form.landXmbhList = [];
      this.form.landArea = null;
      // 不清空 areaCode，保持用户选择的地区
    },
    // 新增：开始日期变化时，自动调整结束日期
    'form.startDate': function (newVal, oldVal) {
      if (newVal && newVal !== oldVal && this.form.orderType) {
        this.setEndDateByOrderType(this.form.orderType);
      }
    },
  },
  methods: {
    // 获取弹窗标题
    getDialogTitle() {
      if (this.form.orderType === '2') {
        return '找农机';
      }
      return this.isEdit ? '编辑托管' : '发布托管';
    },
    // 根据托管类型设置结束日期
    setEndDateByOrderType(orderType) {
      // 日期格式化函数
      const formatDate = (date) => {
        const d = new Date(date);
        const month = '' + (d.getMonth() + 1);
        const day = '' + d.getDate();
        const year = d.getFullYear();
        return [
          year,
          month.padStart(2, '0'),
          day.padStart(2, '0')
        ].join('-');
      };

      if (!this.form.startDate) {
        // 如果没有开始日期，使用当前日期
        const today = new Date();
        this.form.startDate = formatDate(today);
      }

      const startDate = new Date(this.form.startDate);
      let endDate = new Date(startDate);

      if (orderType === '1') {
        // 全程托管，增加一年
        endDate.setFullYear(startDate.getFullYear() + 1);
      } else if (orderType === '2') {
        // 环节托管，增加七天
        endDate.setDate(startDate.getDate() + 7);
      }

      this.form.endDate = formatDate(endDate);
    },

    // 添加选择的地块
    async openLandDialog() {
      // console.log('openLandDialog 方法被调用');
      this.landDialogVisible = true;
      // console.log('landDialogVisible 设置为:', this.landDialogVisible);

      try {
        //查询本人的流转地块
        // console.log('开始调用 findUserXmxxs API');
        let res = await findUserXmxxs()
        // console.log('API 响应:', res);

        if (res && Array.isArray(res.data)) {
          this.landList = res.data;
        } else {
          this.landList = [];
        }
        // console.log(this.landList,'查看获取的this.landList')
      } catch (error) {
        // console.error('获取流转地块失败:', error);
        this.$message.error('获取流转地块失败，请重试');
        this.landList = [];
        // 即使API失败，仍然显示弹窗（可能是空列表）
      }
    },
    // 地块选择回调
    handleLandSelected({ lands, coordinates }) {
      // console.log('接收到的地块数据:', lands, coordinates);

      this.selectedLands = lands;
      this.landNames = lands.map(l => l.xmmc || l.name || `地块${l.id}`).join('、');
      this.CoordinateList = coordinates; // 存储坐标列表
      // 基础地块信息
      this.form.landList = lands.map(l => l.id); // 地块ID列表
      this.form.landXmbhList = lands.map(l => l.xmbh); // 地块编号列表
      //选择的地块地区
      // console.log( lands[0].xzqbh,'查看获取的')
      this.form.areaCode = lands[0].xzqbh;
      this.form.areaName = lands[0].xmdz
      // console.log(JSON.parse(JSON.stringify(lands[0])),'查看获取的所有东西')
      // console.log(this.form.areaName,'查看获取到的地区')
      // 计算最小截止时间
      if (lands && lands.length > 0) {
        const endDates = [];
        let landArea = 0; // 修改为数字类型的变量
        lands.forEach(land => {
          if (land.fbsj && land.lznx) {
            // 发布时间 + 流转年限 = 截止时间
            const publishDate = new Date(land.fbsj);
            const endDate = new Date(publishDate);
            endDate.setFullYear(publishDate.getFullYear() + parseInt(land.lznx));
            endDates.push(endDate);
            //总的选中地块面积
            landArea += land.zcmj;
          }
        });
        this.form.landArea = landArea
        // console.log('总地块面积:', landArea, '亩'); // 添加日志查看总面积

        // console.log(endDates,'查看所有的截止时间')
        // 如果有计算出的截止时间，取最小值
        if (endDates.length > 0) {
          const minEndDate = new Date(Math.min(...endDates));
          // 格式化为 YYYY-MM-DD 格式
          const formatDate = (date) => {
            const d = new Date(date);
            const month = '' + (d.getMonth() + 1);
            const day = '' + d.getDate();
            const year = d.getFullYear();
            return [
              year,
              month.padStart(2, '0'),
              day.padStart(2, '0')
            ].join('-');
          };

          this.form.endDate = formatDate(minEndDate);
          // console.log('设置的最小截止时间:', this.form.endDate);
        }
      }

      // console.log('选中的地块名称:', this.landNames);
      this.landDialogVisible = false;
    },
    // 添加行
    addNFarmers(n) {
      for (let i = 0; i < n; i++) {
        this.form.farmerList.push({
          id: 0,
          farmerNames: "",
          area: "",
          idCard: "",
          phoneNumber: "",
          xmbh: "",
          createTime: "",
          updateTime: "",
          createId: "",
          updateId: "",
          deleted: "",
        });
        // 添加对应的错误状态到 errorStatus 数组
        this.errorStatus.push({
          nameError: false,
          areaError: false,
          identityError: false,
          phoneError: false,
        });
      }

    },
    // 添加单行农户
    addFarmerRow(index) {
      this.form.farmerList.splice(index + 1, 0, {
        id: 0,
        farmerNames: "",
        area: "",
        idCard: "",
        phoneNumber: "",
        xmbh: "",
        createTime: "",
        updateTime: "",
        createId: "",
        updateId: "",
        deleted: "",
      });
      this.errorStatus.splice(index + 1, 0, {
        nameError: false,
        areaError: false,
        identityError: false,
        phoneError: false,
      });
    },
    // 删除单行农户
    removeFarmerRow(index) {
      // 在编辑模式下允许删除所有农户，在新增模式下至少保留一个
      if (this.isEdit || this.form.farmerList.length > 1) {
        this.$confirm('确定要删除该农户吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.form.farmerList.splice(index, 1);
          this.errorStatus.splice(index, 1);

          // 如果农户清单为空，自动取消选中"我是代表多名农户统一流转土地"
          if (this.form.farmerList.length === 0) {
            this.checked1 = false;
          }
        }).catch(() => {
          // 用户取消，无需处理
        });
      }
    },


    validateInput(value, type, index) {
      if (!value) {
        // 输入内容为空，不进行校验
        // 输入内容为空，将当前框的错误状态设置为 false
        switch (type) {
          case "name":
            this.errorStatus[index].nameError = false;
            break;
          case "area":
            this.errorStatus[index].areaError = false;
            break;
          case "id":
            this.errorStatus[index].identityError = false;
            break;
          case "phone":
            this.errorStatus[index].phoneError = false;
            break;
          default:
          // do nothing
        }
        return;
      }
      let regex;
      switch (type) {
        case "name":
          regex = /^[\u4e00-\u9fa5]+$/;
          break;
        case "area":
          regex = /^\d+(\.\d+)?$/;
          break;
        case "id":
          regex = /^\d{17}(\d|X|x)$/;
          break;
        case "phone":
          regex = /^1[3456789]\d{9}$/;
          break;
        default:
          regex = /.*/; // 默认不校验
      }

      if (!regex.test(value)) {
        switch (type) {
          case "name":
            this.errorStatus[index].nameError = true;
            break;
          case "area":
            this.errorStatus[index].areaError = true;
            break;
          case "id":
            this.errorStatus[index].identityError = true;
            break;
          case "phone":
            this.errorStatus[index].phoneError = true;
            break;
          default:
          // do nothing
        }
      } else {
        switch (type) {
          case "name":
            this.errorStatus[index].nameError = false;
            break;
          case "area":
            this.errorStatus[index].areaError = false;
            break;
          case "id":
            this.errorStatus[index].identityError = false;
            break;
          case "phone":
            this.errorStatus[index].phoneError = false;
            break;
          default:
          // do nothing
        }
      }
    },
    // 上传时
    shangcuan(file) {
      // console.log(111, file);
      // console.log(333, file);
    },
    //文件点击事件
    async handleFileClick(file) {
      if (this.isEdit) {
        const url = this.baseUrl + "admin/file/get?ossFilePath=" + file.url2;
        let dom = document.createElement("a");
        dom.style.display = "none";
        dom.href = url;
        dom.setAttribute("download", file.name);
        document.body.appendChild(dom);
        dom.click();
      } else {
        const blob = new Blob([file.raw], {
          type: "application/pdf;charset=utf-8",
        });
        const url = window.URL.createObjectURL(blob);
        let dom = document.createElement("a");
        dom.style.display = "none";
        dom.href = url;
        dom.setAttribute("download", file.name);
        document.body.appendChild(dom);
        dom.click();
      }
    },
    //计算单价 面积 总价 blur或者change事件后 值计算。
    calculateTotal(event, all) {
      const unitPrice = this.form.univalentPrice; //单价
      const quantity = this.form.landArea; //面积
      const totalPrice = this.form.estimatePrice; //总价

      if (all) {
        if (totalPrice !== null && quantity !== null) {
          this.TrueUnitPrice = totalPrice / quantity;
          this.form.univalentPrice = (totalPrice / quantity).toFixed(2);
        }
      } else {
        if (unitPrice !== null && quantity !== null) {
          if (unitPrice == parseFloat(this.TrueUnitPrice).toFixed) {
            this.form.estimatePrice = (this.TrueUnitPrice * quantity).toFixed(
              2
            );
          } else {
            this.form.estimatePrice = (unitPrice * quantity).toFixed(2);
          }
        }
      }
    },
    //做编辑功能 回显，有的按element要求的格式，重新定义
    editObj(obj) {
      this.isEdit = true;
      // 先保存原始的cropCode和orderContent，等数据加载完成后再转换
      this.tempCropCodeLabels = obj.cropCode ? obj.cropCode.split(",") : [];
      this.tempOrderContent = obj.orderContent ? obj.orderContent.split(",") : [];
      this.form = {
        ...obj,
        orderContent: [], // 先设为空，等数据加载完成后再设置
        cropCode: [], // 先设为空，等数据加载完成后再转换
      };
      let fileList1 = obj.livePhotos ? JSON.parse(obj.livePhotos) : [];
      this.getViewUrl1(fileList1);
      let fileList = obj.landCertificateUrl
        ? JSON.parse(obj.landCertificateUrl)
        : [];
      this.getViewUrl(fileList);
      let params = {
        orderId: obj.orderId
      }
      selectLandDetail(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          if (data.farmerList == null) {
            data.farmerList = []
          }
          else {
            data.farmerList = data.farmerList.filter(item => item.farmerNames !== "")

            this.form.farmerList = data.farmerList
            this.checked1 = this.form.farmerList.length >= 1 ? true : false;
            this.isAdd = "false"
            if (this.form.farmerList.length) {
              for (let i = 0; i < this.form.farmerList.length; i++) {
                this.errorStatus.push({
                  nameError: false,
                  areaError: false,
                  identityError: false,
                  phoneError: false,
                });

              }
            }

          }
          // if(data.farmersList.length > 0){
          // this.form.farmerList=data.farmerList
          // }
          this.showEdit = true;
        }
      })

    },
    //现场照片 回显 url拼成 https开头格式，url2是服务器的文件路径，用来做删除功能等
    getViewUrl1(arr) {
      arr.forEach(async (item) => {
        item.url2 = item.url;
        item.url = this.baseUrl + "admin/file/get?ossFilePath=" + item.url;
      });
      this.fileList1 = arr;
    },
    //产权凭证 回显 url拼成 https开头格式，url2是服务器的文件路径，用来做删除功能等
    getViewUrl(arr) {
      arr.forEach(async (item) => {
        item.url2 = item.url;
        item.url = this.baseUrl + "admin/file/get?ossFilePath=" + item.url;
      });
      this.fileList = arr;
    },
    //做文件上传
    async uploadFile(file, filelist, type) {
      let param = new FormData();
      param.append("catalog", "vip");
      param.append("file", file.raw);
      let res = await uploadFile(param);
      if (res.code == 0) {
        this.loading = false;
        file.url2 = res.data.url;
        if (type === "xczp") {
          this.fileList1 = filelist;
        } else {
          this.fileList = filelist;
          this.form.landCertificateUrl =
            this.fileList.length > 0 ? this.getFileParams(this.fileList) : "";
          this.$refs.form.validateField("landCertificateUrl");
        }
      } else {
        this.loading = false;
        this.$message.error(res.msg ? res.msg : "上传失败");
      }
    },
    async uploadXczp(file, filelist) {
      // 文件上传之前的函数
      const isJPG =
        file.raw.type === "image/jpeg" || file.raw.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 6;
      if (!isJPG) {
        this.$message.error("上传图片为 JPG 或 PNG 格式!");
        this.isUpload = false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 6MB!");
        this.isUpload = false;
      }

      if (isJPG && isLt2M) {
        let res = await this.uploadFile(file, filelist, "xczp");
      } else {
        // return
        this.$message.error("上传失败");
      }
      // this.beforeUpload(file)
    },
    //行政区做切换
    regionChange(e) {
      try {
      //    let node = this.$refs.address.getCheckedNodes()[0];
      // console.log(node,'查看node')
      // this.areaHasChild = node.hasChildren;
      // this.form.regionCode = node.value;
      // this.form.areaName = node.pathLabels.join("/");
      // console.log(' this.areaHasChild ',  this.areaHasChild )
      // console.log('this.form.regionCode', this.form.regionCode)
      // console.log('this.form.areaName',  this.form.areaName)
      
      // 选择regionCode后，获取第二级地址数据
        console.log(e);
        if (e.length == 3) {
          // this.form.regionCode = e[2].value;
          // this.form.areaName = e[2].pathLabels.join("/");
          this.tempregionCode = e[2];
          this.getStreets();
        }
      } catch (error) {
        console.log(error);
      }
     
      
      // setTimeout(() => {
      //   this.$refs.form.validateField("areaCode");
      // }, 100);
    },
    streetChange(e){
      // 处理第二级地址选择后的其他业务逻辑
      if (e && e.length == 2) {
        this.form.areaCode = e[1];
        // this.form.landType = "";
        // 重置作物选择
        this.form.cropCode = [];
        console.log(e[1]);
        
        this.getlandScope(
          String(e[1]).length > 6 ? String(e[1]).substring(0, 6) : e[1]
        );
      }
      // let node = this.$refs.address.getCheckedNodes()[0];
      
      // if (node && node.value && node.value.length > 9) {
      //   console.log('去请求');
        
        
      // }
    },
    //文件删除
    async deleteFile(url) {
      let res = await deleteFile({ ossFilePath: url });
      if (res.code == 0 && res.data == true) {

      }
    },
    //根据行政区获取获取土地类型及种养品种
    async getlandScope(areaCode) {
      // console.log('这里执行了嘛')
      let res = await getCropContentCascading({
        areaCode: areaCode,
      });
      this.$nextTick(() => {
        this.zypzArr = res.data;

        // 如果是编辑状态且有临时保存的cropCode labels，进行转换
        if (this.isEdit && this.tempCropCodeLabels && this.tempCropCodeLabels.length > 0) {
          this.form.cropCode = this.convertLabelsToValues(this.tempCropCodeLabels);
          this.changeZypz(this.form.cropCode); // 获取托管环节
          this.tempCropCodeLabels = null; // 清空临时数据
        }
        // 如果不是编辑状态，默认选择旱地
        // else if (!this.isEdit) {
        //   //默认旱地为第一选项
        //   const hanDi = Array.isArray(this.zypzArr) ? this.zypzArr.find(item => item && item.label === '旱地') : null;
        //   if (hanDi && Array.isArray(hanDi.children) && hanDi.children.length > 0) {
        //     this.form.cropCode = hanDi.children.map(child => [hanDi.value, child.value]);
        //     this.changeZypz(this.form.cropCode); // 新增：自动获取托管环节
        //   }
        //   //默认旱地的值
        //   this.form.landType = "旱地"
        // }
      })

      // console.log(this.zypzArr,'查看获取的数据是什么啊')

    },
    async getCropContent(id) {
      // console.log('这里需要的是托管环节',id)

      let res = await getCropContent({id});
      if (res.data && res.code == 0) {
        res.data.forEach((item) => {
          item.label = item.categoryName;
          item.value = item.id;
        });
        return res.data;
      }
    },
    // 土地类型改变，触发托管作物改变
    //  async changeLandType(name) {

    //       console.log(name,'查看name')
    //     this.zypzArr = [];
    //     this.form.landType = name;
    //     // if (!this.changeZypz) {
    //     //   this.form.cropCode = [];
    //     //   this.form.orderContent = [];
    //     // }
    //     // let id = [];
    //     // this.form.cropCode.forEach(item => {
    //     //   if (Array.isArray(item) && item.length > 1) {
    //     //     id.push(item[1]);
    //     //   }
    //     // });
    //     // this.zypzArr = await this.getCropContent(id.join(','));
    //   },
    // 种养品种改变 触发托管环节改变
    async changeZypz(name) {
      // console.log(name,'查看name')
      if (name && name.length > 0) {
        // if (!this.changeZypz) {
        //   this.form.orderContent = [];
        // }
        let zwlxIdArr = [];
        this.tghjArr = [];
        name.forEach((pz) => {
          if (Array.isArray(pz) && pz.length > 1) {
            zwlxIdArr.push(pz[1]); // 使用子项的value作为ID
          }
        });
        // console.log('zwlxIdArr有没有值',zwlxIdArr.join(','))

        if (zwlxIdArr.length > 0) {
          this.tghjArr = await this.getCropContent(zwlxIdArr.join(","));
        }
      } else {
        this.tghjArr = [];
      }
      // 处理托管环节的设置
      if (Array.isArray(this.tghjArr)) {
        // 如果是编辑状态且有临时保存的orderContent，使用临时保存的值
        if (this.isEdit && this.tempOrderContent) {
          this.form.orderContent = this.tempOrderContent;
          this.tempOrderContent = null; // 清空临时数据
        }
        // 如果是全程托管且非编辑状态，自动选择所有环节
        else if (this.form.orderType === '1') {
          this.form.orderContent = this.tghjArr.map(item => item.label);
        }
      }
    },
    //移除产权凭证
    removeCqpz(file, fileList) {
      this.fileList = fileList;
      // if (this.isEdit) {
      //   this.deleteFile(file.url2);
      // }
    },
    //移除现场照片
    removeXczp(file, fileList) {
      this.fileList1 = fileList;
      // if (this.isEdit) {
      //   this.deleteFile(file.url2);
      // }
    },
    //上传产权凭证
    async uploadCqpz(file, filelist) {

      // 文件上传之前的函数

      // const isLt2M = file.size / 1024 / 1024 < 6;
      // if (!isLt2M) {
      //   this.$message.error("上传图片大小不能超过 6MB!");
      //  return
      // }
      // console.log(22222, filelist, file);
      // fileList.forEach((file) => {
      if (file.name.toLowerCase().endsWith("pdf")) {
        // 修改符合条件的文件对象的 url 属性
        file.url =
          "https://tse2-mm.cn.bing.net/th/id/OIP-C.or-hk0X7YoPwI6IzdXK7sgHaHa?w=168&h=180&c=7&r=0&o=5&dpr=1.5&pid=1.7";
      }
      // });
      const fileType = file.raw.type;
      // 检查文件类型是否为 PDF 或图片
      if (fileType !== "application/pdf" && !fileType.startsWith("image/")) {
        // 如果文件类型既不是 PDF 也不是图片
        this.$message.error("只能上传 PDF 文件和图片");
        // var index = filelist.indexOf(file);
        // filelist.splice(index, 1);

        this.fileList = filelist; // 这里可能是你想要更新文件列表的地方

        return false; // 阻止文件上传
      } else {
        // 如果文件类型是 PDF 或图片

        // this.fileList=fileList
        // this.fileList = fileList
        // console.log("this.fileList", this.fileList);
        this.loading = true; // 设置加载状态为 true，显示加载中的UI
        try {
          let res = await this.uploadFile(file, filelist, "cqpz"); // 调用上传文件的方法
          // 处理上传成功的逻辑，例如显示成功消息等
        } catch (error) {
          // 处理上传失败的逻辑，例如显示错误消息等
        } finally {
          this.loading = false; // 无论上传成功或失败，都将加载状态设为 false，隐藏加载中的UI
        }
      }
      // console.log("this.fileList", this.fileList);
    },



    handleExceed2(files, fileList) {
      this.message.warning(`请最多上传6张图片。`);
    },
    beforeUpload(file) {
      // 文件上传之前的函数
      const isJPG =
        file.raw.type === "image/jpeg" || file.raw.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 6;
      if (!isJPG) {
        this.$message.error("上传图片为 JPG 或 PNG 格式!");
        this.isUpload = false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 6MB!");
        this.isUpload = false;
      }
      return isJPG && isLt2M;
    },
    //根据upload里的filelist数组，将文件传后端格式 自定义成自己需要的格式
    getFileParams(arr) {
      let list = [];
      arr.forEach((item) => {
        list.push({
          url: item.url2,
          name: item.name,
        });
      });
      return JSON.stringify(list);
    },
    //计算开始时间和结束时间相差多长时间
    getTime(beginTime, endTime) {
      var dateSpan, iDays;
      let sDate1 = new Date(beginTime).getTime();
      let sDate2 = new Date(endTime).getTime();
      dateSpan = sDate2 - sDate1;
      dateSpan = Math.abs(dateSpan);
      iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
      // console.log(iDays,'这是天数')
      //判断全程托管时间是否大于一年如果大于一年必须上传产权凭证
      if (this.form.orderType == 1 && iDays > 365) {
        this.formRules.landCertificateUrl = [
          { required: true, message: "请上传产权凭证", trigger: "change" },
        ];
      } else {
        this.formRules.landCertificateUrl = [];
      }
    },
    async submit() {
      //环节托管产权凭证不必传
      if (this.form.orderType == 1) {
        this.formRules.landCertificateUrl = [
          { required: true, message: "请上传产权凭证", trigger: "change" },
        ];
      } else {
        this.formRules.landCertificateUrl = [

        ];
      }
      for (let error of this.errorStatus) {
        // console.log("error", error);
        if (
          error.nameError ||
          error.areaError ||
          error.identityError ||
          error.phoneError
        ) {
          // 如果任何一个错误状态为 true，则显示相应的错误信息或采取其他措施
          this.$message.error("农户列表有错");
          return; // 退出函数，防止继续提交
        }
      }
      // let params = Object.assign(this.form);
      // console.log(params,'查看这是什么')

      this.getTime(this.form.startDate, this.form.endDate);
      this.form.userId = this.userInfo.id;
      this.form.farmerName = this.identityObj.realName;
      this.form.farmerPhone = this.userInfo.phone;
      this.form.landCertificateUrl =
        this.fileList.length > 0 ? this.getFileParams(this.fileList) : "";
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let params = {
            orderContent: this.form.orderContent.join(","),
            cropCode: this.convertValuesToLabels(this.form.cropCode).join(","),
            livePhotos: this.fileList1.length > 0
              ? this.getFileParams(this.fileList1)
              : ""
          };
          // 移除landList字段，不传递给后端
          const { landList, ...formWithoutLandList } = this.form;
          // console.log('提交给后端的完整数据:', JSON.parse(JSON.stringify({ ...formWithoutLandList, ...params })));
          let res = await wytgAdd({ ...formWithoutLandList, ...params });


          if (res.code == 0) {
            //上传选择的地块信息
            const orderId = res.data; // 获取订单ID

            // 循环上传地块坐标信息
            if (this.CoordinateList && this.CoordinateList.length > 0) {
              try {
                for (let i = 0; i < this.CoordinateList.length; i++) {
                  const coordinate = this.CoordinateList[i];
                  let params = {
                    orderId: orderId,
                    shape: coordinate.shape
                  };

                  await addOrderAsset(params);
                }
                // console.log("地块信息上传成功");
              } catch (error) {
                console.error("地块信息上传失败:", error);
                this.$message.warning("地块信息上传部分失败，但托管发布成功");
              }
            }

            // console.log("res...", res);
            this.$message.success({
              message: this.isEdit ? "修改成功" : "发布成功",
              offset: 85,
            });
            this.$parent.reset();
            this.back();
          } else {
            this.$message.error(this.isEdit ? "修改失败" : "发布失败");
          }
        } else {
          this.$message.error("请完善发布信息");
        }
      });
    },
    back() {
      this.$emit("closeDialog", false);
    },
    handleClose() {
      this.$emit("closeDialog", false);
    },
    async getRegions() {
      // 获取地区信息
      let res = await getXzqArr({
        level: 3,
      });
      if (res.code == 0) {
        let hasRegion = setInterval(() => {
          this.regionOptions = removeEmptyChildren(res.data);
          this.keyForm++;
          clearInterval(hasRegion);
        }, 100);
      }
    },
    async getStreets() {
      // 获取街道信息
      let res = await getXzqArr({
        level: 5,
        parentCode: this.tempregionCode,
      });
      if (res.code == 0) {
        let hasRegion = setInterval(() => {
          this.streetOptions = removeEmptyChildren(res.data);
          this.keyForm++;
          clearInterval(hasRegion);
        }, 100);
      }
    },
    // 将选中的values转换为对应的labels
    convertValuesToLabels(valueArray) {
      if (!Array.isArray(valueArray) || !Array.isArray(this.zypzArr)) return [];

      const labels = [];
      valueArray.forEach(values => {
        if (Array.isArray(values) && values.length === 2) {
          const [parentValue, childValue] = values;
          // 找到对应的父级
          const parent = this.zypzArr.find(item => item.value === parentValue);
          if (parent && parent.children) {
            // 找到对应的子级
            const child = parent.children.find(item => item.value === childValue);
            if (child) {
              labels.push(child.label);
            }
          }
        }
      });
      return labels;
    },
    // 将labels转换为对应的values用于回显
    convertLabelsToValues(labelArray) {
      if (!Array.isArray(labelArray) || !Array.isArray(this.zypzArr)) return [];

      const values = [];
      labelArray.forEach(label => {
        // 遍历所有父级和子级找到对应的label
        this.zypzArr.forEach(parent => {
          if (parent.children) {
            parent.children.forEach(child => {
              if (child.label === label) {
                values.push([parent.value, child.value]);
              }
            });
          }
        });
      });
      return values;
    },
  },
  components: {
    LandSelectDialog,
  },
};
</script>
<style lang="less" scoped>
/deep/.el-form-item {
  width: 45% !important;

  .el-input {
    width: 260px;
  }
}

/deep/.el-dialog {
  margin-top: 3vh !important;
}

/deep/.el-dialog__body {
  padding-left: 90px;
  padding-bottom: 0;
}

.sends-info {
  padding-bottom: 20px;
  text-align: left;

  .form {
    text-align: left;
    // width: 679px;
    margin: 0 auto;
    margin-top: 28px;
    padding: 0 150px 0px 50px;

    .el-radio-group {
      text-align: left;
    }

    .el-radio-button,
    .el-radio-button__inner {
      margin-right: 16px;
      width: 89px;
    }
  }

  .form-item-con {
    height: 50px;
  }
}


/*人员名单*/
input {
  border: none;
  /* 移除边框 */
  font-size: 16px;
  /* 设置字体大小为默认大小 */
  // padding: 4px; /* 设置内边距 */
  outline: none;
  /* 移除选中时的边框 */
}

/deep/.el-upload-list__item {
  width: 30%;
}

/deep/.el-upload-list {
  display: flex;
  flex-wrap: wrap;
}

.farmers-table {
  width: 100%;
  border-collapse: collapse;
}

.farmers-table th,
.farmers-table td {
  // text-align: center;
  width: auto !important;
  padding: 8px;
  border: 1px solid #ddd;

  input {
    text-align: center;
    width: 100%;
    border: none;
    /* 移除边框 */
    font-size: 16px;
    /* 设置字体大小为默认大小 */
    // padding: 4px; /* 设置内边距 */
    outline: none;
    /* 移除选中时的边框 */
  }
}

.farmers-table th {
  background-color: #f2f2f2;
}

table {
  /deep/.el-input {
    border: 1px solid gray;
    width: 80%;
  }

  /deep/.el-select {
    width: 80%;

    .el-input {
      width: 100%;
    }

    .el-input.is-focus .el-input__inner {
      border-color: transparent;
    }
  }

  /deep/.el-input-group__append {
    padding: 0 12px;
  }

  /deep/.el-input__inner:focus {
    border: none !important;
  }

  /deep/.el-input__inner:hover {
    border-color: transparent !important;
  }

  /deep/.el-input__inner {
    height: 32px;
    line-height: 32px;
  }

  border-collapse: collapse;

  tr {
    color: #333;

    td {
      width: 160px;
      text-align: center;
      height: 12px;
      padding: 6px;

      span {
        color: red;
      }
    }

    td:nth-child(2n) {
      width: 380px !important;
    }

    .dis {
      background: #d2d4d7;
      cursor: disabled;
    }
  }
}

/deep/.el-dialog__body {
  padding-left: 130px;
}

.upload-demo .pdf i::before {
  content: "\f1c1";
  /* Font Awesome 中的 PDF 图标编码 */
}

.upload-demo .file i::before {
  content: "\f15b";
  /* Font Awesome 中的文件图标编码 */
}

.error-cell {
  // background-color: lightcoral;
  border-bottom: 3px solid red !important;
}

.farmer-btn-group {
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
}

/deep/ .el-form-item {
  align-items: center !important;
}

/* 流转地块选择样式优化 */
.land-select-container {
  width: 100%;

  .land-select-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    .selected-count {
      color: #409EFF;
      font-weight: 500;
      font-size: 14px;
    }
  }

  .selected-lands-info {
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 16px;
    margin-top: 12px;

    .selected-lands-header {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      font-weight: 600;
      color: #333;

      i {
        margin-right: 8px;
        color: #409EFF;
      }
    }

    .selected-lands-content {
      .land-item {
        background: white;
        border: 1px solid #e9ecef;
        border-radius: 6px;
        padding: 12px;
        margin-bottom: 8px;
        transition: all 0.3s ease;

        &:hover {
          border-color: #409EFF;
          box-shadow: 0 2px 4px rgba(64, 158, 255, 0.1);
        }

        &:last-child {
          margin-bottom: 0;
        }

        .land-item-info {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;

          .land-name {
            font-weight: 600;
            color: #333;
            font-size: 15px;
          }

          .land-area {
            background: #e7f3ff;
            color: #409EFF;
            padding: 4px 8px;
            border-radius: 4px;
            font-size: 12px;
            font-weight: 500;
          }
        }

        .land-item-details {
          display: flex;
          gap: 16px;

          .land-detail {
            color: #666;
            font-size: 12px;

            &:before {
              content: "•";
              color: #409EFF;
              margin-right: 4px;
            }
          }
        }
      }
    }

    .total-area {
      margin-top: 12px;
      padding-top: 12px;
      border-top: 1px solid #e9ecef;
      text-align: right;

      span {
        background: #f0f9ff;
        color: #0369a1;
        padding: 6px 12px;
        border-radius: 4px;
        font-weight: 600;
        font-size: 14px;
      }
    }
  }

  .no-selected-lands {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px;
    background: #fafafa;
    border: 2px dashed #d9d9d9;
    border-radius: 8px;
    color: #999;
    margin-top: 12px;

    i {
      margin-right: 8px;
      font-size: 18px;
    }

    span {
      font-size: 14px;
    }
  }
}
</style>
